import { SkillType } from '@/enums';
import { AppDispatch, RootState } from '@/models';
import { createLessons, fetchSkillsMetadata } from '@/store/slices/WeeklyPlanSlice';
import { createListenerMiddleware } from '@reduxjs/toolkit';

export const addFetchSkillsMetadataListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: createLessons,
    effect: async (action, listenerApi) => {
      const state = listenerApi.getState();
      const curriculum = state.weeklyPlan.data?.curriculum;

      if (!curriculum) return;

      const skillIds = new Set(
        curriculum.tracks
          .flatMap(track => track.units)
          .flatMap(unit => unit.lessons)
          .flatMap(lesson => lesson.skills.filter(s => s.skillType === SkillType.FOCUS))
          .map(skill => skill.skillId)
          .filter((id): id is string => !!id)
      );

      if (skillIds.size > 0) {
        await listenerApi.dispatch(
          fetchSkillsMetadata({ skillIds: Array.from(skillIds) })
        );
      }
    }
  });
};
